/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tree-modular.vue?vue&type=template&id=1c6db878&scoped=true&"
import script from "./tree-modular.vue?vue&type=script&lang=ts&"
export * from "./tree-modular.vue?vue&type=script&lang=ts&"
import style0 from "./tree-modular.vue?vue&type=style&index=0&id=1c6db878&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6db878",
  null
  
)

export default component.exports